import { render, staticRenderFns } from "./Oxford.vue?vue&type=template&id=8bbbf9ec&scoped=true"
import script from "./Oxford.vue?vue&type=script&lang=js"
export * from "./Oxford.vue?vue&type=script&lang=js"
import style0 from "./Oxford.vue?vue&type=style&index=0&id=8bbbf9ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbbf9ec",
  null
  
)

export default component.exports